import { Flex, Heading } from '@utilitywarehouse/hearth-react';
import { ReactNode } from 'react';

import './index.scss';

export type Feature = {
  id: string;
  icon: ReactNode;
  title: string;
  body?: string;
};

type FeaturesProps = {
  features: Feature[];
  titleAsHeading?: boolean;
};

const Title = ({
  title,
  titleAsHeading,
}: Pick<Feature, 'title'> & Pick<FeaturesProps, 'titleAsHeading'>) => {
  if (titleAsHeading) {
    return (
      <Heading size="md" asChild>
        <span className="features__title">{title}</span>
      </Heading>
    );
  }

  return <span className="features__title">{title}</span>;
};

const Body = ({ body }: Pick<Feature, 'body'>) => {
  if (!body) {
    return null;
  }

  return <span>{body}</span>;
};

export const Features = ({ features, titleAsHeading }: FeaturesProps) => {
  if (features.length === 0) {
    return null;
  }

  return (
    <ul className="features">
      {features.map(({ id, icon, title, body }) => (
        <li key={id} className="features__item">
          <Flex flexShrink="0">{icon}</Flex>
          <Flex direction="column">
            <Title title={title} titleAsHeading={titleAsHeading} />
            <Body body={body} />
          </Flex>
        </li>
      ))}
    </ul>
  );
};
